module.exports = __webpack_public_path__ + "img/ot-qiusdc.cd18646e.png";